var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "63px",
    viewBox: "0 0 60 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Schedule",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Schedule-(-Coach-)-new",
    transform: "translate(-1583.000000, -507.000000)",
    fill: "#F22B5D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1583.000000, 507.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0983607,31.4754098 L27,31.4754098 C26.9016393,31.4754098 26.704918,31.4262295 26.704918,31.3278689 L26.704918,30.6393443 C26.704918,30.5901639 26.8032787,30.4918033 27,30.4918033 L27.0983607,30.4918033 C27.1967213,30.4918033 27.3934426,30.5409836 27.3934426,30.6393443 L27.3934426,31.3770492 C27.3934426,31.4262295 27.1967213,31.4754098 27.0983607,31.4754098",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4972191,31.7080686 C27.4972191,32.1733862 27.163515,32.5722298 26.8298109,32.5722298 L26.5628476,32.5722298 C26.1624027,32.5722298 25.8954394,32.1733862 25.8954394,31.7080686 L25.8954394,28.7167414 L24.0266963,28.7832153 C23.8932147,28.7832153 23.759733,28.6502675 23.759733,28.4508456 C23.759733,28.2514238 23.8932147,28.1184759 24.0266963,28.1184759 L25.9621802,28.052002 L25.9621802,27.5202105 C25.9621802,27.0548929 26.2958843,26.6560493 26.6295884,26.6560493 L26.8965517,26.6560493 C27.2969967,26.6560493 27.56396,27.0548929 27.56396,27.5202105 L27.56396,31.7080686 L27.4972191,31.7080686 Z M46.1846496,56.8352173 L46.1846496,4.71964963 L30.0333704,4.71964963 L30.0333704,0 L15.9510567,4.71964963 L15.5506118,4.71964963 L15.5506118,56.7687434 L0,56.7687434 L0,58.297644 L16.21802,58.297644 L29.9666296,62.9508197 L29.9666296,6.24855021 L44.6496107,6.24855021 L44.6496107,58.297644 L60,58.297644 L60,56.7687434 L46.1846496,56.7687434 L46.1846496,56.8352173 Z",
    id: "Fill-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingRoom);
export default __webpack_public_path__ + "static/media/waitingRoom.1244e6e383244bdfd2564741636552a2.svg";
export { ForwardRef as ReactComponent };